/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebsitImageConfigInfoRespVo } from './WebsitImageConfigInfoRespVo';
import {
    WebsitImageConfigInfoRespVoFromJSON,
    WebsitImageConfigInfoRespVoFromJSONTyped,
    WebsitImageConfigInfoRespVoToJSON,
    WebsitImageConfigInfoRespVoToJSONTyped,
} from './WebsitImageConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseListWebsitImageConfigInfoRespVo
 */
export interface ResponseListWebsitImageConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListWebsitImageConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListWebsitImageConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<WebsitImageConfigInfoRespVo>}
     * @memberof ResponseListWebsitImageConfigInfoRespVo
     */
    data?: Array<WebsitImageConfigInfoRespVo>;
}

/**
 * Check if a given object implements the ResponseListWebsitImageConfigInfoRespVo interface.
 */
export function instanceOfResponseListWebsitImageConfigInfoRespVo(value: object): value is ResponseListWebsitImageConfigInfoRespVo {
    return true;
}

export function ResponseListWebsitImageConfigInfoRespVoFromJSON(json: any): ResponseListWebsitImageConfigInfoRespVo {
    return ResponseListWebsitImageConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponseListWebsitImageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListWebsitImageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(WebsitImageConfigInfoRespVoFromJSON)),
    };
}

export function ResponseListWebsitImageConfigInfoRespVoToJSON(json: any): ResponseListWebsitImageConfigInfoRespVo {
    return ResponseListWebsitImageConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponseListWebsitImageConfigInfoRespVoToJSONTyped(value?: ResponseListWebsitImageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(WebsitImageConfigInfoRespVoToJSON)),
    };
}

